// extracted by mini-css-extract-plugin
module.exports = {"heading":"ProductInfo_heading__Gnuw0","sub_heading":"ProductInfo_sub_heading__5Nmw2"};